import utils from 'utils'
import addOperatorPage from './views/addOperator.html'
import addReceiverPage from './views/addReceiver.html'

export default class ApplicationAddCtrl {
    constructor($scope, logger, $uibModal, httpRequest, $state, sweetalert, $timeout) {
        const userInfo = JSON.parse(localStorage.user_info)
        var ukeyList = userInfo.sysUkeyList;
        const orgId = userInfo.org.orgId;
        if(null!=ukeyList && ukeyList.length>0){
            var u_index = 0;
            ukeyList.forEach((item) => {
                u_index++;
                if(orgId!=item.orgId || item.diskType==1 || (item.diskType==2 && item.diskCode!=0 && item.manageType!=4)){
                    //不是本机构的设备，服务器盘，金税盘不是0号盘的都屏蔽
                    u_index--
                    ukeyList.splice(u_index,1)
                }
            });
        }else{
            ukeyList = null;
        }
        $scope.ukeyList = ukeyList
        $scope.diskId = null==ukeyList?'':ukeyList[0].diskId
        $scope.selectedUkey = null
        $scope.selectedDevice = null
        if(null!=ukeyList && ukeyList.length>0){
            $scope.selectedUkey = ukeyList[0].ukeyId
            $scope.selectedDevice = ukeyList[0]
        }
        $scope.invTypeList = [] //票种授权
        $scope.operators = [] //经办人
            /**
         * 获取收货人列表
         */
        function getReceiverList() {
            httpRequest.get_getConsigneeListBySale().then((data) => {
                $scope.receivers = data.data.value
                $scope.selectedReceiver = $scope.receivers[0]
            })
        }
        /**
         * 获取申领权限，能申领的发票种类，每个种类的最大限额
         */
        function getApplyAuth() {
            if(!$scope.selectedDevice){
                logger.logError('请先维护开票点!')
                return
            }
            var data = {}
            var saleCreditCode = JSON.parse(localStorage.user_info).sale.saleCreditCode
            data.taxNo = saleCreditCode;
            if($scope.selectedDevice.diskType=='2'){
                data.approvedType = '1'
                //金税盘电子发票传1，先只支持电子发票的购买
            }else{
                data.approvedType = '0'
            }
            utils.loading('获取发票种类授权中')
            httpRequest.post_queryNsrInvoiceTypeApproval(data).then((res)=>{
                if(res.data.value.businessData.approvedInfos){
                    res.data.value.businessData.approvedInfos.forEach((item, index) => {
                        var invType = {}
                        invType.invoiceTypeCode = item.invoiceCategoryCode
                        invType.invoiceTypeName = item.invoiceCategoryName
                        invType.invoiceLimitCount = item.eachPurchaseInvoiceLimit
                        invType.invoiceCategory = item.invoiceCategory
                        $scope.invTypeList.push(invType)
                    })
                    $scope.currentInvType = $scope.invTypeList[0]
                    $scope.currentInvType.invoiceLimitCount = Number($scope.currentInvType.invoiceLimitCount)
                    $scope.applicationInfo.invoiceTypeCode = $scope.currentInvType.invoiceTypeCode
                    $scope.applicationInfo.applyCount = $scope.currentInvType.invoiceLimitCount
                    $scope.currentInvType.applyNum = 1
                    if($scope.currentInvType.invoiceCategory=='5' || $scope.currentInvType.invoiceCategory=='6'){
                        //电子普票 或 电子专票
                        $scope.applicationInfo.applyWay = '1'
                    }
                    utils.loaded()
                    //获取经办人
                    getOperatorList()
                }
            },(error)=>{
                logger.logError(error)
                utils.loaded()
            })

            /*stockService.getApplyAuth().then((res) => {
                const reg = {
                    code: /(<CODE>)(.*?)(<\/CODE>)/g,
                    invoiceTypeName: /<FPZLMC>(.*?)<\/FPZLMC>/g, // 发票种类名称
                    invoiceTypeCode: /<FPZLDM>(.*?)<\/FPZLDM>/g, // 发票种类代码
                    invoiceLimitCount: /<MCFPXE>(.*?)<\/MCFPXE>/g, // 每次发票限额
                    invoiceType: /<FPZL>(.*?)<\/FPZL>/g, // 发票种类
                }
                const result = utils.analysisXml(reg, res)
                $scope.invTypeList = result.value
                $scope.currentInvType = $scope.invTypeList[0]
                $scope.currentInvType.invoiceLimitCount = Number($scope.currentInvType.invoiceLimitCount)
                $scope.applicationInfo.invoiceTypeCode = $scope.currentInvType.invoiceTypeCode
                $scope.currentInvType.applyNum = 1
                getOperatorList()
            }, (error) => {
                logger.logError(error)
                // $state.go('outputManage.stock.application.list')
            })*/
        }
        /**
         * 获取诺诺申领权限，能申领的发票种类，每个种类的最大限额，经办人信息
         */
        function getNuoNuoApplyAuth() {
            if(!$scope.selectedDevice){
                logger.logError('请先维护开票点!')
                return
            }
            var data = {}
            var saleCreditCode = JSON.parse(localStorage.user_info).sale.saleCreditCode
            data.taxNo = saleCreditCode;
            if($scope.selectedDevice.diskType=='2'){
                data.approvedType = '1'
                //金税盘电子发票传1，先只支持电子发票的购买
            }else{
                data.approvedType = '0'
            }
            utils.loading('获取发票种类授权中')
            httpRequest.get_getPrepareInvoiceApply(data.taxNo).then((res)=>{
                if(res.data.value.invoiceTypeDetails){
                    res.data.value.invoiceTypeDetails.forEach((item, index) => {
                        var invType = {}
                        invType.invoiceTypeCode = item.fplxdm
                        invType.invoiceTypeName = item.fpzlmc  // fpzlmc 发票种类名称
                        invType.invoiceLimitCount = item.zgcpl // zgcpl 最高持票量
                        invType.fplxdm = item.fplxdm           // fplxdm 发票类型代码
                        invType.fpzldm = item.fpzldm           // fpzldm 发票种类代码

                        $scope.invTypeList.push(invType)
                    })
                    $scope.currentInvType = $scope.invTypeList[0]
                    console.log($scope.invTypeList)
                    $scope.currentInvType.invoiceLimitCount = Number($scope.currentInvType.invoiceLimitCount)
                    $scope.applicationInfo.applyCount = $scope.currentInvType.invoiceLimitCount
                    $scope.applicationInfo.invoiceTypeCode = $scope.currentInvType.invoiceTypeCode
                    $scope.currentInvType.applyNum = 1

                    res.data.value.operatorDetails.forEach((item, index) => {
                        var operator = {}
                        operator.operatorName = item.jbrxm
                        operator.certType = item.zjlx
                        operator.certNo = item.zjhm
                        $scope.operators.push(operator)
                    })
                    $scope.selectedOperator = $scope.operators[0]

                    utils.loaded()
                }
            },(error)=>{
                logger.logError(error)
                utils.loaded()
            })
        }
        /**
         * 从e税云获取经办人信息
         * @return {[type]} [description]
         */
        function getOperatorListFromCloud() {
            return httpRequest.get_getOperatorListBySale().then((res2) => {
                $scope.operators.splice(1)
                $scope.operators = $scope.operators.concat(res2.data.value)
            })
        }
        /**
         * 获取经办人信息 从两个系统取 只有成功才能网上申领
         * @return {[type]} [description]
         */
        function getOperatorList() {
            var data = {}
            var saleCreditCode = JSON.parse(localStorage.user_info).sale.saleCreditCode
            data.taxNo = saleCreditCode;
            utils.loading('获取企业经办人信息')
            httpRequest.post_queryOperator(data).then((res)=>{
                if(res.data.value.businessData){
                    res.data.value.businessData.forEach((item, index) => {
                        var operator = {}
                        operator.operatorName = item.name
                        operator.certType = item.typeOfCertificate
                        operator.certNo = item.idNumber
                        $scope.operators.push(operator)
                    })
                    $scope.selectedOperator = $scope.operators[0]
                }
                utils.loaded()
            },(error)=>{
                logger.logError(error)
                utils.loaded()
            })
            /*stockService.queryZglx().then((res1) => {
                const reg = {
                    code: /(<CODE>)(.*?)(<\/CODE>)/g,
                    certType: /<ZJLX>(.*?)<\/ZJLX>/g,
                    certNo: /<ZJHM>(.*?)<\/ZJHM>/g,
                    operatorName: /<JBRXM>(.*?)<\/JBRXM>/g,
                }
                const result = utils.analysisXml(reg, res1)
                result.value.forEach((item, index) => {
                    // 标识税局返回  不能删除
                    item.isDefault = true
                    item.operatorId = -index - 1
                })
                $scope.operators = result.value
                getOperatorListFromCloud().then(() => {
                    $scope.selectedOperator = $scope.operators[0]
                })
            }, (error) => {
                logger.logError(error)
                // $state.go('outputManage.stock.application.list')
            })*/
        }

        function init() {
            $scope.applicationInfo = {
                applyCount: '', // 申领数量
                applyWay: '2', //  领票方式：快递配送、国税领取
                invoiceTypeCode: '',
                diskNo: ''
            }
            // 收货人
            $scope.receivers = []
            // 经办人
            $scope.operators = []
            // 当前选中发票种类
            $scope.currentInvType = {}
            // 选中的收货人
            $scope.selectedReceiver = {}
            // 选中的经办人
            $scope.selectedOperator = {}
            // 表单校验提示
            $scope.errorMsg = ''
            /*httpRequest.get_dictByTypeArr('["cert_type"]').then((res) => {
                $scope.dictionary = res.data.value
            })*/
            $scope.dictionary = {
                cert_type: [{enumTypeCode: "cert_type", enumName: "身份证", enumCode: "201", remark: null},{enumTypeCode: "cert_type", enumName: "护照", enumCode: "227", remark: null},{enumTypeCode: "cert_type", enumName: "军官证", enumCode: "202", remark: null}]
            }
            var selectedDisk = null;
            ukeyList.forEach((item) => {
                if(item.diskId==$scope.diskId){
                    selectedDisk = item
                }
            });
            if(selectedDisk.manageType==4){
                $scope.manageType = 4
                getNuoNuoApplyAuth()
                getReceiverList()
            }else {
                getApplyAuth()
                getReceiverList()
                //getOperatorList()
            }

        }
        init()
        $scope.reload = function reload(){
            init()
        }
        // 打开收件人信息窗口
        function openAddReceiverDialog(receiver) {
            return $uibModal.open({
                template: addReceiverPage,
                controller: 'addReceiverDialogCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-lg',
                resolve: {
                    receiver() {
                        return receiver
                    },
                },
            }).result
        }

        // 打开经办人信息窗口
        function openAddOperatorDialog(operator) {
            return $uibModal.open({
                template: addOperatorPage,
                controller: 'addOperatorDialogCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-lg',
                resolve: {
                    operator() {
                        return operator
                    },
                },
            }).result
        }
        // 添加经办人
        $scope.addOperator = function addOperator(operator) {
            if (!operator && $scope.operators.length === 3) {
                logger.logError('最多添加3个经办人')
                return
            }
            openAddOperatorDialog(operator).then((o) => {
                if (operator) {
                    Object.assign(operator, o)
                } else {
                    $scope.operators.push(o)
                }
            })
        }
        $scope.addReceiver = function addReceiver(receiver) {
            if (!receiver && $scope.receivers.length === 10) {
                logger.logError('最多添加10个收货地址')
                return
            }
            openAddReceiverDialog(receiver).then(getReceiverList)
        }
        $scope.invTypeChange = function invTypeChange() {
            $scope.invTypeList.forEach((invType, index) => {
                if ($scope.applicationInfo.invoiceTypeCode === invType.invoiceTypeCode) {
                    $scope.currentInvType = invType
                    $scope.applicationInfo.applyCount = $scope.currentInvType.invoiceLimitCount
                    $scope.currentInvType.applyNum = index + 1
                    if($scope.currentInvType.invoiceCategory=='5' || $scope.currentInvType.invoiceCategory=='6'){
                        //电子普票 或 电子专票
                        $scope.applicationInfo.applyWay = '1'
                    }
                }
            })
        }
        /**
         * 显示操作链接
         */
        $scope.showOperation = function showOperation(item, flag) {
            item.showOperation = flag
        }
        /**
         * 设置默认地址
         */
        $scope.setDefault = function setDefault(receiver, index) {
            httpRequest.post_updateConsignee({ ...receiver, defaultFlag: 1 }).then(() => {
                receiver.showOperation = false
                $scope.receivers.splice(index, 1)
                $scope.receivers.forEach((item) => {
                    item.defaultFlag = 0
                    item.showOperation = false
                })
                receiver.defaultFlag = 1
                $scope.receivers.unshift(receiver)
            })
        }
        $scope.validateRules = {
            applyCount: [{
                erromsg: '超出最大领购份数',
                condition(value) {
                    // 规则
                    return value > $scope.currentInvType.invoiceLimitCount
                },
            }, {
                erromsg: '发票数量为正整数',
                condition(value) {
                    // 规则
                    return value < 1
                },
            }],
        }
        function validateWithMsg(applyCount) {
            if (!applyCount && applyCount !== 0) {
                return '必填项'
            } if (applyCount > $scope.currentInvType.invoiceLimitCount) {
                return '不能大于最大可购票量'
            } if (applyCount < 1) {
                return '发票数量为正整数'
            }
            return ''
        }
        /**
         * 提交
         * @return {[type]} [description]
         */
        $scope.submit = function submit() {
            $scope.errorMsg = validateWithMsg($scope.applicationInfo.applyCount)
            if ($scope.errorMsg) {
                return
            }
            if (!$scope.selectedOperator) {
                logger.logError('未选择经办人信息，请选择后提交')
                return
            }
            if($scope.currentInvType.invoiceCategory=='5' || $scope.currentInvType.invoiceCategory=='6'){
                //电子普票 或 电子专票
                $scope.applicationInfo.applyWay = '1'
            }
            var selectedDisk = null;
            ukeyList.forEach((item) => {
                if(item.diskId==$scope.diskId){
                    selectedDisk = item
                }
            });
            if(selectedDisk.manageType==4){
                if ($scope.applicationInfo.applyWay === '2') {
                    if (!$scope.selectedReceiver) {
                        logger.logError('未选择收货人信息，请选择后提交')
                        return
                    }
                }
                let distType = null;
                if(selectedDisk.diskType ==2){distType = 0}
                if(selectedDisk.diskType ==3){distType = 2}
                if(selectedDisk.diskType ==4){distType = 1}
                const requestData = {
                    identityType: $scope.selectedOperator.certType,   // identityType  证件类型，可选：201-身份证、208-护照 ,
                    identityCode: $scope.selectedOperator.certNo,     // identityCode 证件号码 ,
                    applyNum: $scope.applicationInfo.applyCount,      // applyNum  申领数量 ,
                    deviceType: distType,           // deviceType  设备类型:0-金税盘、1-税控盘、2-UKEY , diskType
                    invoiceCode: $scope.currentInvType.fpzldm,        // invoiceCode  发票种类代码,具体联次 ,
                    invoiceLine: $scope.currentInvType.fplxdm,        // invoiceLine  发票类型代码:p-电普票、c-纸普票、s-专 票 ,
                    applyName: $scope.selectedOperator.operatorName,  // applyName  经办人姓名 ,
                    receiveMode: $scope.applicationInfo.applyWay,     // receiveMode 1-自行领票、2-快递邮寄 ,
                    receiverAddr: !$scope.selectedReceiver?'':$scope.selectedReceiver.addressInfo,        // receiverAddr  收件人地址，快递邮寄 时必填 ,
                    receiverName: !$scope.selectedReceiver?'':$scope.selectedReceiver.consigneeName,       // receiverName  收件人姓名，快递邮寄 时必填 ,
                    receiverTel: !$scope.selectedReceiver?'':$scope.selectedReceiver.mobile,              // receiverTel  收件人手机号，快递邮寄 时必填 ,
                    postCode: !$scope.selectedReceiver?'':$scope.selectedReceiver.zipCode,              // postCode  邮编，快递邮寄 时必填 ,
                    remark: '0', //remark  申领说明
                    taxNum: JSON.parse(localStorage.user_info).sale.saleCreditCode     // taxNum 税号
                }

                utils.loading('提交申领中')
                httpRequest.post_submitInvoiceApply(requestData).then((res)=>{
                    //申领结果
                    console.log("申领结果：" + res)
                    if(res.data.success){
                        logger.logSuccess('提交成功')
                        $timeout(() => {
                            $state.go('outputManage.stock.application.list')
                        }, 500)
                    }
                    utils.loaded()
                },(error)=>{
                    utils.loaded()
                    logger.logError(error)
                })
            }else {
                if ($scope.applicationInfo.applyWay === '2' && $scope.currentInvType.invoiceCategory !== '5' && $scope.currentInvType.invoiceCategory!=='6') {
                    if (!$scope.selectedReceiver) {
                        logger.logError('未选择收货人信息，请选择后提交')
                        return
                    }
                }
                const requestData = {
                    applicantCertificateType: $scope.selectedOperator.certType,
                    applicantIdNumber: $scope.selectedOperator.certNo,
                    applicationInstructions: '',
                    applicationQuantity: $scope.applicationInfo.applyCount,
                    invoiceCategory: $scope.currentInvType.invoiceCategory,
                    invoiceCategoryCode: $scope.applicationInfo.invoiceTypeCode,
                    manager: $scope.selectedOperator.operatorName,
                    obtainingMethod: $scope.applicationInfo.applyWay,
                    recipientAddress: '',
                    recipientFixedTelephone: '',
                    recipientMobilePhone: '',
                    recipientName: '',
                    recipientPostalCode: '',
                    remarks: '',
                    taxNo: JSON.parse(localStorage.user_info).sale.saleCreditCode
                }
                utils.loading('提交申领中')
                httpRequest.post_invoiceApply(requestData).then((res)=>{
                    //申领结果
                    console.log("申领结果：" + res)
                    if(res.data.success){
                        logger.logSuccess('提交成功')
                        $timeout(() => {
                            $state.go('outputManage.stock.application.list')
                        }, 500)
                    }
                    utils.loaded()
                },(error)=>{
                    utils.loaded()
                    logger.logError(error)
                })
            }
        }
        /*$scope.submit = function submit() {
            $scope.errorMsg = validateWithMsg($scope.applicationInfo.applyCount)
            if ($scope.errorMsg) {
                return
            }
            if (!$scope.selectedOperator) {
                logger.logError('未选择经办人信息，请选择后提交')
                return
            }
            const requestData = {
                appStatus: '',
                buyStatus: '',
            }
            // currentInvType： 选择序号FPZLDM/发票种类FPZL/发票种类代码FPZLDM/每次最大购票量MCFPXE
            // applicationInfo：申领数量SLSL，领票方式SLFS
            Object.assign(requestData, $scope.currentInvType, $scope.applicationInfo, $scope.selectedOperator)
            // const userName = JSON.parse(localStorage.getItem('user_info')).user.userName
            delete requestData.createUser
            delete requestData.updateUser
            if ($scope.applicationInfo.applyWay === '2' && $scope.currentInvType.invoiceType !== '026') {
                if (!$scope.selectedReceiver) {
                    logger.logError('未选择收货人信息，请选择后提交')
                    return
                }
                Object.assign(requestData, $scope.selectedReceiver)
            }
            if ($scope.currentInvType.invoiceType === '026') {
                requestData.applyWay = '1'
            }
            // 税局提交
            stockService.submitApplication(requestData).then((data) => {
                const reg = {
                    applySn: /<DATA>(.*?)<\/DATA>/g,
                }
                const submitResult = utils.analysisXml(reg, data).value[0]
                if (submitResult.applySn) {
                    // 获取applySn申领序列号
                    Object.assign(requestData, submitResult)
                    httpRequest.post_addOnlineApplyRecord(requestData).then(() => {
                        logger.logSuccess('提交成功')
                        $timeout(() => {
                            $state.go('outputManage.stock.application.list')
                        }, 500)
                    })
                } else {
                    $state.go('outputManage.stock.application.list')
                }
            }, (error) => {
                logger.logError(error)
            })
        }*/

        $scope.deleteReceiver = function deleteReceiver(id, index) {
            sweetalert.confirm('操作提醒', '确认删除该收货人地址').then(() => {
                httpRequest.post_deleteConsignee(id).then(() => {
                    logger.logSuccess('删除成功')
                    $scope.receivers.splice(index, 1)
                    if (id === $scope.selectedReceiver.consigneeId) {
                        $scope.selectedReceiver = $scope.receivers[0]
                    }
                })
            })
        }
        $scope.deleteOperator = function deleteOperator(id, index) {
            if (!id) {
                return
            }
            sweetalert.confirm('操作提醒', '确认删除该经办人').then(() => {
                httpRequest.post_deleteOperator(id).then(() => {
                    logger.logSuccess('删除成功')
                    $scope.operators.splice(index, 1)
                    if (id === $scope.selectedOperator.operatorId) {
                        $scope.selectedOperator = $scope.operators[0]
                    }
                })
            })
        }
        $scope.selectReceiver = function selectReceiver(receiver) {
            $scope.selectedReceiver = receiver
        }
        $scope.selectOperator = function selectOperator(operator) {
            $scope.selectedOperator = operator
        }
    }
}
ApplicationAddCtrl.$inject = ['$scope', 'logger', '$uibModal', 'httpRequest', '$state', 'sweetalert', '$timeout']



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/application/applicationAddCtrl.js